import { useStyletron } from '@thanx/uikit/theme'
import React from 'react'
import { previewColors } from './previewTheme'

const APP_ICON_SIZE = '30px'
const APP_ICON_RADIUS = '7px'

export interface AppIconProps {
  /** The merchant's uploaded logo; falls back to the brand-red placeholder
   * square when omitted (no logo uploaded). */
  appIconUrl?: string
  /** Icon edge length; defaults to the iOS Live Activity size. Android's
   * Material notification uses a smaller 24px mark. */
  size?: string
  /** Corner radius; defaults to the iOS treatment. Android Material uses 4px. */
  radius?: string
}

// The app icon shared by both Live Activity platform cards: the merchant's logo
// when uploaded, else a decorative brand-red placeholder square — the visible
// title conveys the info either way, so both variants are aria-hidden.
const AppIcon = ({
  appIconUrl,
  size = APP_ICON_SIZE,
  radius = APP_ICON_RADIUS,
}: AppIconProps) => {
  const [css] = useStyletron()
  return appIconUrl ? (
    <img
      src={appIconUrl}
      alt=""
      aria-hidden="true"
      className={css({
        width: size,
        height: size,
        borderRadius: radius,
        objectFit: 'cover',
        flexShrink: 0,
      })}
    />
  ) : (
    <div
      aria-hidden="true"
      className={css({
        width: size,
        height: size,
        borderRadius: radius,
        backgroundColor: previewColors.brandRed,
        flexShrink: 0,
      })}
    />
  )
}

export default AppIcon
